import { type NamePath } from '@xbcb/ui-types';
import { useAppRecordContext } from 'context/appRecordContext';
import { ValidationErrors } from 'libs/entryValidation/ValidationErrors';
import { useTypedSelector } from 'reducers';

export interface UseEntryValidation {
  validated: boolean;
  errorMessages: string[];
  validateFields: NamePath[];
  validator: ValidationErrors | null;
}

export const useEntryValidation = (
  path: NamePath,
  excludedKeys?: string[],
): UseEntryValidation => {
  const { recordId } = useAppRecordContext();
  const entryValidation = useTypedSelector(
    (state) => state.validation[recordId],
  );
  if (!entryValidation)
    return {
      validated: false,
      errorMessages: [],
      validateFields: [],
      validator: null,
    };
  const validator = new ValidationErrors(entryValidation.errorMap);

  const errorMessages =
    validator.getErrorMessages({ path, excludedKeys }) ?? [];
  return {
    validated: true,
    errorMessages,
    validateFields: entryValidation.validateFields,
    validator,
  };
};
